import { PLACES, LBL, PTS, ptsTxt, bg, canVoteEmail, VOTE_DOMAINS } from "../lib/api";

const Card = ({ e, ballot, canVote, onPick, onOpen }) => {
  const place = PLACES.find((p) => ballot[p] === e.id);
  return (
    <div className={`card${place ? " picked" : ""}`} data-testid={`lion-card-${e.id}`}>
      <button className="ph" style={bg(e.photoId)} aria-label={`Ver foto de ${e.name}`}
        onClick={() => onOpen(e)} data-testid={`lion-photo-${e.id}`} />
      {e.mine && <span className="mine" data-testid="my-lion-badge">Tu león</span>}
      {place && <span className="medal">{LBL[place]}</span>}
      <div className="body">
        <div className="who">{e.name || "Participante"}</div>
        {e.lionName && <div className="lion">«{e.lionName}»</div>}
        {!e.mine && canVote && (
          <div className="chips">
            {PLACES.map((p) => (
              <button key={p} type="button" className={ballot[p] === e.id ? "on" : ""}
                aria-pressed={ballot[p] === e.id} onClick={() => onPick(p, e.id)}
                data-testid={`vote-${p}-${e.id}`}>
                {LBL[p]}<small>{ptsTxt(PTS[p])}</small>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export const Gallery = ({ data, loaded, ballot, canVote, email, onPick, onOpen }) => {
  const entries = data?.entries || [];
  const blocked = email && !canVoteEmail(email) && data?.config.votingOpen;
  return (
    <section className="on" data-testid="gallery-section">
      <h2>Galería</h2>
      <p className="hint">Toca <b>1º</b>, <b>2º</b> o <b>3º</b> en tus tres leones favoritos y guarda tus votos abajo. Puedes cambiarlos mientras la votación siga abierta. No puedes votar por tu propio león.</p>
      {data && !data.config.votingOpen && <div className="banner" data-testid="voting-closed-note">{data.config.deadlinePassed ? "La votación cerró el viernes 6 de noviembre a las 12:00 (CDMX)." : "La votación está cerrada."}</div>}
      {blocked && <div className="banner err" data-testid="vote-domain-rejected">Tu correo no puede votar. Solo pueden votar correos {VOTE_DOMAINS.join(", ")}. Puedes subir tu león con cualquier correo.</div>}
      <div className="grid">
        {!entries.length ? (
          <div className="empty" style={{ gridColumn: "1/-1" }} data-testid="gallery-empty">
            <b>{loaded ? "Aún no hay leones" : "Cargando leones…"}</b>{loaded && "¡Sé el primero en subir el tuyo!"}
          </div>
        ) : entries.map((e) => (
          <Card key={e.id} e={e} ballot={ballot} canVote={canVote} onPick={onPick} onOpen={onOpen} />
        ))}
      </div>
    </section>
  );
};
